import React from 'react';
import { Region } from '../../types/orderTypes';
import { HubSortListOrderEntry } from '../../hooks/useFetchHubSortList';

import './RegionTableBar.scss';
import {
  ParsedScannedOrders,
  parseScannedOrders,
  ProgressScanningTodaySummary,
} from '../ProgressScanningTodaySummary/ProgressScanningTodaySummary';
import { COLOR } from '../../const/color';

interface Props {
  region: Region;
  orders: HubSortListOrderEntry[];
}

function showShelfIdColor(parseScannedOrdersResult: ParsedScannedOrders) {
  if (
    parseScannedOrdersResult.remaining === 0 &&
    parseScannedOrdersResult.inProgress === 0 &&
    parseScannedOrdersResult.completed > 0
  ) {
    return COLOR.PROGRESS_GREEN;
  } else if (
    parseScannedOrdersResult.remaining === 0 &&
    parseScannedOrdersResult.inProgress > 0 &&
    parseScannedOrdersResult.completed >= 0
  ) {
    return COLOR.PROGRESS_YELLOW;
  } else if (parseScannedOrdersResult.remaining > 0) {
    return COLOR.PROGRESS_RED;
  } else if (
    parseScannedOrdersResult.remaining === 0 &&
    parseScannedOrdersResult.inProgress === 0 &&
    parseScannedOrdersResult.completed === 0
  ) {
    return COLOR.PROGRESS_BLACK;
  } else {
    return COLOR.PROGRESS_PURPLE;
  }
}

export default function RegionTableBar({ region, orders }: Props) {
  const scannedOrders = parseScannedOrders(orders);

  return (
    <div className="u-pbl">
      <div className="region-table-bar">
        <div
          className="region-table-bar__name"
          style={{
            backgroundColor: showShelfIdColor(scannedOrders),
          }}
        >
          <span>{region}</span>
        </div>
        <ProgressScanningTodaySummary scannedOrders={scannedOrders} />
      </div>
    </div>
  );
}
